module.exports = __webpack_public_path__ + "img/zwnr.856a15b6.png";